import React from "react";
import { WidgetFrame } from "../../../personal-studio-components/studio";
import * as cls from "./attestationTheme.module.scss";
import ModalAttestationTheme from "../../components/modalAttestationTheme/ModalAttestationTheme";
function AttestationTheme(props) {
  return (
    <div>
      {/* <div className={cls.head_title}>Выбор темы ВКР</div> */}
      <WidgetFrame type="blue" icon="survey" title="Выбор темы ВКР" colspan={2}>
        Заявка на утверждение темы ВКР будет рассматриваться и утверждаться на
        последнем курсе обучения за 6 месяцев до начала периода итоговой
        аттестации. Одновременно Вам будет назначен научный руководитель.
        <ModalAttestationTheme />
      </WidgetFrame>
    </div>
  );
}

export default AttestationTheme;
